import { TYPES } from '../flattenTree/utils/consts';
import { deletePropertyByPath } from './deleteMembers';
import { applyToMembers } from './applyToMembers';
import { shouldRemove, shouldAddSortOrder } from './predicates';
import { createNewCategoriesEffect } from './createNewCategories';
import { changeMembersNameEffect } from './changeMembersNames';
import { addSortOrderProperty } from './addSortOrderProperty';
import { moveMembersToCategories } from './moveMembersToCategories';

const applyVisibilityEffect = (docsTree, category, isEditMode) => {
  if (isEditMode) {
    return;
  }
  if (!category.visible) {
    deletePropertyByPath(docsTree, category.path, TYPES.CATEGORY);
    return;
  }
  applyToMembers(
    category,
    (member) => deletePropertyByPath(docsTree, member.path, member.type),
    shouldRemove,
  );
};

const applyChangeNameEffect = (docsTree, category, isEditMode) => {
  const functionToApply = (member) => {
    return changeMembersNameEffect(docsTree, member, isEditMode, category);
  };
  applyToMembers(
    category,
    functionToApply,
    (member) => member.type !== TYPES.CATEGORY,
  );
  changeMembersNameEffect(docsTree, category, isEditMode);
};

const applySortOrderEffect = (docsTree, category) => {
  shouldAddSortOrder(category) &&
    addSortOrderProperty(docsTree, { ...category, type: TYPES.CATEGORY });
  applyToMembers(
    category,
    (member) => addSortOrderProperty(docsTree, member),
    shouldAddSortOrder,
  );
};

const applyMovingApisEffect = (docsTree, category) => {
  moveMembersToCategories(docsTree, category);
};
export const applyMenuConfigChanges = (docsTree, menuConfig, isEditMode) => {
  createNewCategoriesEffect(docsTree, menuConfig);
  menuConfig.categories.forEach((category) => {
    applyMovingApisEffect(docsTree, category);
    applyVisibilityEffect(docsTree, category, isEditMode);
    applySortOrderEffect(docsTree, category);
  });
  menuConfig.categories.forEach((category) => {
    applyChangeNameEffect(docsTree, category, isEditMode);
  });
  return docsTree;
};
